import { observer } from 'mobx-react-lite'
import DetailsSection from '../common/DetailsSection'
import DetailsValue from '../common/DetailsValue'
import yesNo from 'util/yesNo'

type LifestyleSectionProps = {
  // TODO: improve visit type
  visit: any
}

const LifestyleSection = ({ visit }: LifestyleSectionProps) => {
  const { lifestyle } = visit?.memberExtendedData?.privateData?.medicalHistory || {}

  const { smoke, vape, drink, sexuallyActive, drinkFrequency } = lifestyle || {}

  if (!lifestyle) {
    return null
  }

  return (
    <DetailsSection title="Lifestyle">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-6 gap-y-4">
        <DetailsValue label="Smoke / Use Tobacco" value={yesNo(smoke)} />
        <DetailsValue label="Vape" value={yesNo(vape)} />
        <DetailsValue label="Sexually Active" value={yesNo(sexuallyActive)} />
        <DetailsValue
          label="Drink / How Often"
          value={`${yesNo(drink)}${drink && drinkFrequency ? `, ${drinkFrequency}` : ''}`}
        />
      </div>
    </DetailsSection>
  )
}

export default observer(LifestyleSection)
